var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxAlandIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.625 -0.00939941H-3.20025V44.9997H65.625V-0.00939941Z",
    fill: "#0053A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4482 -0.00939941H31.2126V44.9997H44.4482V-0.00939941Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.625 15.8762H-3.20025V29.1141H65.625V15.8762Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4775 -0.00939941H35.1833V44.9997H40.4775V-0.00939941Z",
    fill: "#D21034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.625 19.8475H-3.20025V25.1427H65.625V19.8475Z",
    fill: "#D21034"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxAlandIslands);
export default __webpack_public_path__ + "static/media/ax Aland Islands.0d13d536fb97920a04ad2c2ae507c2dc.svg";
export { ForwardRef as ReactComponent };